import z from 'zod';
import {
  optionalMinMaxLength,
  zodRedirectSchema,
  zodStringOptionSchema,
} from '../../../../Validators';

export const redirectsSchema = z
  .object({
    _id: z
      .string({
        required_error: 'Supplier ID is required.',
        invalid_type_error: 'Expected string for Supplier ID.',
      })
      .trim()
      .min(1, { message: 'Supplier ID cannot be empty.' }),
    globalRedirects: z
      .boolean({
        required_error: 'Global Redirects value is required.',
        invalid_type_error: 'Expected boolean value for Global Redirects.',
      })
      .optional(),
    countryRedirects: z
      .boolean({
        required_error: 'Country Redirects value is required.',
        invalid_type_error: 'Expected boolean value for Country Redirects.',
      })
      .optional(),
    customRedirection: z
      .boolean({
        required_error: 'Custom Redirects value is required.',
        invalid_type_error: 'Expected boolean value for Custom Redirects.',
      })
      .optional(),
    redirects: zodRedirectSchema.optional(),
    encryptionAlgorithm: zodStringOptionSchema.optional(),
    encryptionKey: optionalMinMaxLength(1, undefined, 'Encryption Key'),
    encryptionType: zodStringOptionSchema.optional(),
    saltValue: optionalMinMaxLength(1, undefined, 'Salt value'),
    hashName: optionalMinMaxLength(1, undefined, 'Hash Name'),
    preHash: z
      .boolean({
        required_error: 'Pre Hash is required!',
        invalid_type_error: 'Pre Hash must be type boolean!',
      })
      .optional(),
    preHashValues: z
      .object({
        complete: z
          .string({
            required_error: 'complete link is required !',
            invalid_type_error: 'complete link must be a string',
          })
          .trim(),
        terminate: z
          .string({
            required_error: 'terminate link is required !',
            invalid_type_error: 'terminate link must be a string',
          })
          .trim(),
        securityTerminate: z
          .string({
            required_error: 'security terminate link is required !',
            invalid_type_error: 'security terminate link must be a string',
          })
          .trim(),
        quotaFull: z
          .string({
            required_error: 'quota full link is required !',
            invalid_type_error: 'quota full link must be a string',
          })
          .trim(),
      })
      .optional(),
    showAdvancedOptions: z
      .boolean({
        required_error: 'Show Advance options is required!',
        invalid_type_error: 'Show Advance options must be type boolean!',
      })
      .optional(),
    previewLink: optionalMinMaxLength(1, undefined, 'Preview Link'),
  })
  .superRefine((data, ctx) => {
    if (data.preHash) {
      if (!data.preHashValues) {
        ctx.addIssue({
          path: ['preHashValues'],
          message: 'preHashValues is required when Pre Hash is true.',
          code: 'custom',
        });
      } else {
        Object.entries(data.preHashValues).forEach(([key, value]) => {
          if (!value) {
            ctx.addIssue({
              path: ['preHashValues', key],
              message: `${key} is required when Pre Hash is true.`,
              code: 'custom',
            });
          }
        });
      }
    }
    if (data.globalRedirects) {
      if (!data.redirects) {
        ctx.addIssue({
          path: ['redirects'],
          message: 'redirects is required when Global Redirects is true.',
          code: 'custom',
        });
      } else {
        Object.entries(data.redirects).forEach(([key, value]) => {
          if (!value) {
            ctx.addIssue({
              path: ['redirects', key],
              message: `${key} is required when Global Redirects is true.`,
              code: 'custom',
            });
          }
        });
      }
    }
  });
